import styled, { css } from 'styled-components';

export const WrapperTitle = styled.span`
  ${({ theme }) => css`
    display: flex;
    color: initial;
    font: inherit;
    align-items: center;

    fuel-icon {
      margin-right: ${theme.spacing.km3};
    }
  `}
`;
